import { Checkbox, DataHeader, DataSource, HorizontalSpacer, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementMulticurrency extends Layout {
    apanelMCDirectDeposit1: Panel;
    apanelMCDirectDeposit2: Panel;
    apanelMCDirectDeposit3: Panel;
    checkboxDirDepHoliday: Checkbox;
    checkboxDirDepPrintdebit: Checkbox;
    checkboxDirDepSaturday: Checkbox;
    checkboxDirDepSepfileCo: Checkbox;
    checkboxDirDepSunday: Checkbox;
    checkboxPrintZeroDebit: Checkbox;
    dataheaderSettlementMulticurrency: DataHeader;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    horizontalspacer7: HorizontalSpacer;
    panelAccounts: Panel;
    sourcePayrollControlMulticurrency: DataSource;
    tabMCAccounts: Tab;
    tabMCDirectDeposit: Tab;
    tabsetMulticurrency: Tabset;
    textboxAchBatchClassCode: Textbox;
    textboxDirDepClassDescCCD: Textbox;
    textboxAchOptionalSecurityLn: Textbox;
    textboxAgentCashGlid: Textbox;
    textboxBankNumber: Textbox;
    textboxCarrierCashGlid: Textbox;
    textboxCarrierInterfaceCashGlid: Textbox;
    textboxCoDiscrData: Textbox;
    textboxContractCashGlid: Textbox;
    textboxCpaCode: Textbox;
    textboxCurrencyType: Textbox;
    textboxDirDepClassDesc: Textbox;
    textboxDirDepCompId: Textbox;
    textboxDirDepDays: Textbox;
    textboxDirDepDestFlag: Textbox;
    textboxDirDepDestName: Textbox;
    textboxDirDepFilename: Textbox;
    textboxDirDepFormat: Textbox;
    textboxDirDepMinAmt: Textbox;
    textboxDirDepOrigName: Textbox;
    textboxDirDepOrigNum: Textbox;
    textboxDriverCashGlid: Textbox;
    textboxFedReserveNum: Textbox;
    textboxFuelCashGlid: Textbox;
    textboxLeaseopCashGlid: Textbox;
    textboxOfficeCashGlid: Textbox;
    textboxOriginatorId: Textbox;
}
